import { Injectable } from '@angular/core';
import { MappingsItemSettings } from 'src/app/nav-processing/mappings/mappings.model';
import {
  WatchPeyeResponseCallback,
  WatchPeyeResultsCallback,
} from '../nav-driver/peye/peye.service';
import { NativePluginService } from '../nativePlugin/nativePlugin.service';
import { WatchEyeResultsCallback } from '../nav-driver/rastreador/rastreador.service';

@Injectable({
  providedIn: 'root',
})
export class AndroidControlService {
  constructor(private nativePlugin: NativePluginService) {}

  async test() {
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.echo({ value: 'Hello World!' });
      console.log('Response from native:', value);
    }
  }

  async startCamera() {
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.startCamera({
        value: 'Hello World!',
      });
      console.log('Response from native:', value);
    }
  }

  async startCameraPreview() {
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.startCameraPreview({
        value: 'startCameraPreview!',
      });
      console.log('Response from native:', value);
    }
  }

  async stopCamera() {
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.stopCamera({
        value: 'Hello World!',
      });
      console.log('Response from native:', value);
    }
  }

  async receiveConfig(settingsArray: Array<MappingsItemSettings>) {
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.receiveConfig({
        value: settingsArray,
      });
      console.log('Response from native receiveConfig:', value);
    }
  }

  async setCameraState(stringResp: string) {
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.setCameraState({
        value: stringResp,
      });
      console.log('Response from native:', value);
    }
  }

  async nativeResult() {
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.nativeResult({
        value: 'nativeResult',
      });
      console.log('Response from native:', value);
    }
  }

  async startPeyeTracker() {
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.startPeyeTracker({
        value: 'Hello World!',
      });
      console.log('Response from native:', value);
    }
  }

  async resultPeyeTracker() {
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.resultPeyeTracker();
      console.log('Response from native:', value);
    }
  }

  async closePeyeConnection() {
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.closePeyeConnection({
        value: 'Hello World!',
      });
      console.log('Response from native:', value);
    }
  }

  async streamingPeyeTracker(callback: WatchPeyeResultsCallback) {
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.streamingPeyeTracker(callback);
      console.log('Response from native:', value);
    }
  }

  async sendPeyeMessage(message: string) {
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.sendPeyeMessage({ value: message });
      console.log('Response from native:', value);
    }
  }

  async receivePeyeMessage(callback: WatchPeyeResponseCallback) {
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.receivePeyeMessage(callback);
      console.log('Response from native:', value);
    }
  }

  async connectPeye() {
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.connectPeye({
        value: 'Hello World!',
      });
      console.log('Response from native:', value);
    }
  }

  async startBt() {
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.startBt({
        value: 'Hello World!',
      });
      console.log('Response from native:', value);
    }
  }

  async getNetworkData(msg: Array<number>): Promise<string[]>{
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.getNetworkData({
        value: msg,
      });
      const result = value.split(','); //transforma string unica em lista de strings
      console.log('Response from native :', result);
      return result;
    }
  }


  async permissionStatus() : Promise<string>{
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.permissionsStatus({
        value: 'Hello World!',
      });
      console.log('Response from native:', value);
      return value;
    }
  }

  async accsvPermission(){
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.accsvPermission({
        value: 'Hello World!',
      });
      console.log('Response from native:', value);
    }
  }
  
  async cameraPermission(){
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.cameraPermission({
        value: 'Hello World!',
      });
      console.log('Response from native:', value);
    }
  }
  
  async getScanInterval(valuen: number){
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.getScanInterval({
        value: valuen
      });
      console.log('Response from native:', value);
    }
  }

  async getTouchDuration(valuen: number){
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.getTouchDuration({
        value: valuen
      });
      console.log('Response from native:', value);
    }
  }

  async startEyeTracker(){
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.startEyeTracker({
        value: 'Hello World!',
      });
      console.log('Response from native:', value);
    }
  }

  async passCoordinates(callback: WatchEyeResultsCallback){
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.passCoordinates(callback);
      console.log('Response from native eyetracker:', value);
    }
  }


  async closeEyeTracker(){
    if (this.nativePlugin.registered) {
      const { value } = await this.nativePlugin.plugin?.closeEyeTracker({
        value: 'Hello World!',
      });
      console.log('Response from native:', value);
    }
  }


 /* async endMessagePeye() {
    if (this.nativePlugin) {
      const { value } = await this.nativePlugin.plugin?.endMessagePeye({
        value: 'Hello World!',
      });
      console.log('Response from native:', value);
    }
  }*/
}
